export default __webpack_public_path__ + "static/media/minimize-hover.6ec1826f.svg";